const PREFS_KEY = 'hms.lab.catalog.operator.prefs'

export type RecentTestEntry = {
  masterId: string
  name: string
  code: string
  at: string
}

export type OperatorPrefs = {
  recentCategories: string[]
  recentSpecimens: string[]
  recentTests: RecentTestEntry[]
}

const MAX_RECENT = 6

function load(): OperatorPrefs {
  try {
    const raw = sessionStorage.getItem(PREFS_KEY)
    if (!raw) return { recentCategories: [], recentSpecimens: [], recentTests: [] }
    const p = JSON.parse(raw) as OperatorPrefs
    return {
      recentCategories: p.recentCategories ?? [],
      recentSpecimens: p.recentSpecimens ?? [],
      recentTests: p.recentTests ?? [],
    }
  } catch {
    return { recentCategories: [], recentSpecimens: [], recentTests: [] }
  }
}

function save(prefs: OperatorPrefs): void {
  sessionStorage.setItem(PREFS_KEY, JSON.stringify(prefs))
}

function bump(list: string[], value: string): string[] {
  const v = value.trim()
  if (!v) return list
  return [v, ...list.filter((x) => x !== v)].slice(0, MAX_RECENT)
}

export function recordCategoryUse(category: string): void {
  const prefs = load()
  prefs.recentCategories = bump(prefs.recentCategories, category)
  save(prefs)
}

export function recordSpecimenUse(specimen: string): void {
  const prefs = load()
  prefs.recentSpecimens = bump(prefs.recentSpecimens, specimen)
  save(prefs)
}

export function recordTestCreated(entry: Omit<RecentTestEntry, 'at'>): void {
  const prefs = load()
  prefs.recentTests = [
    { ...entry, at: new Date().toISOString() },
    ...prefs.recentTests.filter((t) => t.masterId !== entry.masterId),
  ].slice(0, MAX_RECENT)
  save(prefs)
}

export function getOperatorPrefs(): OperatorPrefs {
  return load()
}
